<template>
  <v-row no-gutters>
    <p
      class="px-2 text-body-1 font-weight-bold"
    >{{ $t("payeeDetails.payeeAddressDetails") }}</p>
    <v-form
      v-if="payeeAddress.model && payeeAddress.schema"
      ref="form"
      v-model="isFormValid"
    >
      <v-form-base
        :value="payeeAddress.model"
        :schema="payeeAddress.schema"
        @input="
          onInput($event);
          validateRegEx($event);
        "
      />
    </v-form>
  </v-row>
</template>
<script>
import getFormConfig from '@/util/formUtility.js'
import commonService from '@/service/commonService.js'
import VFormBase from 'dco-vuetify-form'
import event from '@/util/event'
import { rearrangeSchemaBySequence } from '@/composables/useSchemaUtils'
import formFieldsMixin from '@/core/mixins/formFieldsMixin'

export default {
  name: 'PayeeAddressDetails',
  components: {
    VFormBase
  },
  mixins: [formFieldsMixin],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    isPayeeDrawer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      payeeAddress: {
        model: this.value,
        schema: {}
      },
      isFormValid: true,
      countryList: []
    }
  },
  methods: {
    onInput (e) {
      const { key, value } = e
      this.payeeAddress.model[key] = value
      this.$emit('input', this.payeeAddress.model)
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'ISOCountryCode2Char' }]
      }
      const response = await commonService.getGenericCodes(code)
      const countryList = []
      response.aggregateCodes[0].codes.forEach((code) => {
        countryList.push({
          text: code.codeDescription,
          value: code.codeReference
        })
      })
      if (this.payeeAddress.schema.country) {
        this.payeeAddress.schema.country.items = countryList
      }
    }
  },
  watch: {
    isFormValid (newVal) {
      this.$emit('form-validity-change', newVal)
    }
  },
  async created () {
    const response = getFormConfig(await commonService.getFormData(`PayeeAddressDetails-${this.$i18n.locale}`))

    this.payeeAddress = rearrangeSchemaBySequence(response)
    await this.getGenericCodes()

    if (this.isPayeeDrawer) {
      const flex = {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      }
      Object.values(this.payeeAddress.schema).forEach(field => {
        if (field && typeof field === 'object' && field.flex) {
          field.flex = { ...flex }
        }
      })
    }
    event.$on('setCountry', (country) => {
      this.payeeAddress.model.country = country
      this.$emit('input', this.payeeAddress.model)
    })
    event.$on('resetForm', (arg) => {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    })
  }
}
</script>
